module.exports = __webpack_public_path__ + "static/media/5-solution-0.2ba09710.mp3";